var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.phoneNumber)?_c('span',[_vm._v(" "+_vm._s(_vm.type ? _vm.$t(`COMMON.PHONE_TYPE_${_vm.type}`) : null)+" "+_vm._s(_vm.formattedPhone)+" "+_vm._s(_vm.extension ? ` (ext: ${_vm.extension})` : null)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }